// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"2f5b59f9","905":"568bdb79"}[chunkId] + ".chunk.js";
};